
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function AvisoLegal() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Aviso Legal
            </h1>
            <p className="text-xl text-gray-600">
              Información legal sobre el uso de este sitio web
            </p>
          </div>

          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Datos identificativos
              </h2>
              <div className="bg-gray-50 rounded-lg p-6">
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <p className="text-gray-700 mb-2"><strong>Denominación social:</strong> PINTOLOT</p>
                    <p className="text-gray-700 mb-2"><strong>Domicilio:</strong> Olot, Girona, España</p>
                    <p className="text-gray-700 mb-2"><strong>Teléfono:</strong> 609 93 65 90</p>
                  </div>
                  <div>
                    <p className="text-gray-700 mb-2"><strong>Email:</strong> info@pintolot.com.es</p>
                    <p className="text-gray-700 mb-2"><strong>Sitio web:</strong> www.pintolot.com.es</p>
                    <p className="text-gray-700 mb-2"><strong>Actividad:</strong> Servicios de pintura</p>
                  </div>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Objeto y aceptación
              </h2>
              <div className="border border-gray-200 rounded-lg p-6">
                <p className="text-gray-700 mb-4">
                  El presente aviso legal regula el uso del sitio web www.pintolot.com.es, del que es 
                  titular PINTOLOT.
                </p>
                <p className="text-gray-700">
                  La navegación por el sitio web atribuye la condición de usuario del mismo e implica 
                  la aceptación plena y sin reservas de todas y cada una de las disposiciones incluidas 
                  en este Aviso Legal.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Condiciones de uso
              </h2>
              <div className="space-y-4">
                <div className="border border-gray-200 rounded-lg p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2 flex items-center">
                    <i className="ri-shield-check-line text-[#51b038] mr-2"></i>
                    Uso adecuado
                  </h3>
                  <p className="text-gray-700">
                    El usuario se compromete a utilizar el sitio web de conformidad con la ley, el presente 
                    Aviso Legal, las buenas costumbres y el orden público.
                  </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2 flex items-center">
                    <i className="ri-forbid-line text-red-500 mr-2"></i>
                    Prohibiciones
                  </h3>
                  <ul className="text-gray-700 list-disc list-inside space-y-1">
                    <li>Hacer un uso comercial no autorizado de los contenidos</li>
                    <li>Distribuir, modificar o alterar los contenidos</li>
                    <li>Usar el sitio web para fines ilícitos o lesivos</li>
                    <li>Provocar daños en los sistemas físicos o lógicos</li>
                  </ul>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Propiedad intelectual e industrial
              </h2>
              <div className="bg-blue-50 rounded-lg p-6">
                <p className="text-gray-700 mb-4">
                  PINTOLOT es titular de todos los derechos de propiedad intelectual e industrial del 
                  sitio web, así como de los elementos contenidos en el mismo.
                </p>
                <p className="text-gray-700">
                  Todos los derechos reservados. En virtud de lo dispuesto en los artículos 8 y 32.1, 
                  párrafo segundo, de la Ley de Propiedad Intelectual, quedan expresamente prohibidas 
                  la reproducción, la distribución y la comunicación pública de la totalidad o parte 
                  de los contenidos de esta página web.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Responsabilidad
              </h2>
              <div className="border border-gray-200 rounded-lg p-6">
                <p className="text-gray-700 mb-4">
                  PINTOLOT no se hace responsable de los daños y perjuicios que pudieran derivarse de:
                </p>
                <ul className="text-gray-700 list-disc list-inside space-y-2">
                  <li>La falta de disponibilidad o continuidad del sitio web</li>
                  <li>Los errores en el contenido del sitio web</li>
                  <li>La presencia de virus o elementos lesivos en el sitio web</li>
                  <li>El uso ilícito o incorrecto del sitio web</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Enlaces externos
              </h2>
              <div className="border border-gray-200 rounded-lg p-6">
                <p className="text-gray-700">
                  El sitio web puede contener enlaces a otros sitios web. PINTOLOT no ejerce control 
                  alguno sobre dichos sitios web y no es responsable del contenido de ninguno de ellos. 
                  La inclusión de enlaces no implica recomendación o aprobación de los mismos.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Modificaciones
              </h2>
              <div className="bg-yellow-50 rounded-lg p-6">
                <p className="text-gray-700">
                  PINTOLOT se reserva el derecho de efectuar sin previo aviso las modificaciones que 
                  considere oportunas en su sitio web, pudiendo cambiar, suprimir o añadir tanto los 
                  contenidos y servicios que se presten a través de la misma como la forma en la que 
                  éstos aparezcan presentados o localizados.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Legislación aplicable y jurisdicción
              </h2>
              <div className="border border-gray-200 rounded-lg p-6">
                <p className="text-gray-700 mb-4">
                  La relación entre PINTOLOT y el usuario se regirá por la normativa española vigente.
                </p>
                <p className="text-gray-700">
                  Para la resolución de todas las controversias o cuestiones relacionadas con el presente 
                  sitio web o de las actividades en él desarrolladas, será de aplicación la legislación 
                  española, sometiéndose ambas partes a la jurisdicción de los juzgados y tribunales 
                  de Girona.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Contacto
              </h2>
              <div className="bg-green-50 rounded-lg p-6">
                <p className="text-gray-700 mb-4">
                  Para cualquier consulta sobre este Aviso Legal, puede contactar con nosotros:
                </p>
                <div className="space-y-2 text-gray-700">
                  <p className="flex items-center">
                    <i className="ri-mail-line text-[#51b038] mr-2"></i>
                    <strong>Email:</strong> info@pintolot.com.es
                  </p>
                  <p className="flex items-center">
                    <i className="ri-phone-line text-[#51b038] mr-2"></i>
                    <strong>Teléfono:</strong> 609 93 65 90
                  </p>
                </div>
              </div>
            </section>

            <div className="text-center mt-12 pt-8 border-t border-gray-200">
              <p className="text-sm text-gray-500">
                Última actualización: Diciembre 2024
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
